import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import closeIcon from "../../assets/icons/close-new-icon.svg"
import { Spinner } from "react-bootstrap";

const DynamicModal = ({ show, handleClose, children, title, modalClass, formikRef, submitBtnText, isFooter =true , retestOrderIsLoading =false }) => {
    return (
      <Modal
        show={show}
        onHide={handleClose}
        centered
        keyboard={false}
        dialogClassName={`${modalClass}`}
      >
        <Modal.Header>
          <Modal.Title className="modal-title">{title}</Modal.Title>
          <a type="button" className="btn-close-custom" onClick={handleClose}>
            <img src={closeIcon} alt="Close" />
          </a>
        </Modal.Header>
        <Modal.Body className="custom-modal-body">
          <span className="retest-kit-title">Delivery name and address</span>
          <div className="modal-content-wrapper text-mhc-teal">{children}</div>
        </Modal.Body>
        {isFooter && (
          <Modal.Footer>
            <button
              className="btn-login w-100 btn btn-green"
              type="submit"
              onClick={() => formikRef.current?.submitForm()}
            >
              {retestOrderIsLoading ? (
                <div className="text-center">
                  <Spinner
                    animation="border"
                    role="output"
                    className="my-custom-spinner"
                  />
                </div>
              ) : (
                submitBtnText
              )}
            </button>
          </Modal.Footer>
        )}
      </Modal>
    );
};

DynamicModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func,
    children: PropTypes.node,
    titleClassName: PropTypes.string,
    title: PropTypes.string,
    modalClass: PropTypes.string,
    formikRef: PropTypes.object,
};

export default DynamicModal;
